import { HTTPCodes } from '../../constants';
import baseNotFoundImg from '../../assets/images/base-not-found-img.svg';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.not_found}>
      <h1 className={styles.not_found_code}>{HTTPCodes.NOT_FOUND}</h1>
      <div className={styles.not_found_portal}>
        <img src={baseNotFoundImg} alt="" />
        <div className={styles.circle_1} />
        <div className={styles.circle_2} />
        <div className={styles.circle_3} />
        <div className={styles.circle_4} />
        <div className={styles.circle_5} />
      </div>
      <div className={styles.not_found_title}>{t('notFound.title')}</div>
      <p className={styles.not_found_subtitle}>{t('notFound.subtitle')}</p>
    </div>
  );
};

export default NotFound;
